import React, { useEffect, useState } from 'react';
import './index.less';
import './index.h5.less';

import cs from 'classnames';
import Article from '../article';
import Card from '../components/card';
import { useId, useArticleData, isAcademyType, loadSSRData } from '../util';
import Icon from '@components/icon';
import { AcademyLangCode, AdminPathH5, goH5Admin } from '@utils/nav';
import { getClassRecommendList, reportClassRead } from '@service/api';
import { CreationClass } from '@typings/api/novel/toutiao_muye_overseas_homeapi';
import { useTranslation } from '@ies/intl-react-plugin';
import { useUserInfo } from '@utils/hooks';
import Empty from '@components/h5/empty';
import { CreationZone } from '@typings/api/novel/origin_overseas_base';
import { LangCode } from '@common/lang';
import { Tea } from '@utils/tea';
import { EVENTS } from '@constants/event';
import AcademyScore from '../components/score';
import Divider from '@components/divider';

const ArticleH5 = () => {
    const [list, setList] = useState<CreationClass[]>([]);
    const [category, setCategory] = useState<{
        tab?: CreationZone;
        subTab?: string;
    }>({});

    const id = useId();
    const { i18n, t } = useTranslation();
    const { type } = useArticleData();
    const { isLogin } = useUserInfo();

    const lang = i18n.language as LangCode;
    const showAcademy = isAcademyType(type) && lang === LangCode.ID;

    useEffect(() => {
        if (showAcademy) {
            getRecommendList();
            reportAcademy();
        }
    }, [showAcademy]);

    const reportAcademy = () => {
        try {
            reportClassRead({
                language: i18n.language,
                item_id: id,
            });
        } catch (e) {}
    };

    const getRecommendList = async () => {
        try {
            const resp = await getClassRecommendList({
                language: i18n.language,
                item_id: id,
            });
            if (!resp.code) {
                const { creation_class_list, creation_zone, academy_sub_tab } = resp.data;
                setList(creation_class_list);
                setCategory({
                    tab: creation_zone,
                    subTab: academy_sub_tab,
                });
            }
        } catch (e) {}
    };

    const handleClickMore = () => {
        goH5Admin(AdminPathH5.Academy[lang as AcademyLangCode], category);
        Tea(EVENTS.CLICK_ACADEMY_RECOMMENDATION, {
            recommendation_type: 'more',
        });
    };

    return (
        <Article
            className={cs('article-h5', { 'article-h5-academy': showAcademy })}
            isMobile
            bottom={
                showAcademy ? (
                    <>
                        <AcademyScore articleId={id} />
                        <Divider />
                        <div className="article-h5-academy-list">
                            <div
                                className="academy-list-title"
                                onClick={() => (isLogin ? handleClickMore() : undefined)}
                            >
                                {t('academy_recommend')}
                                {isLogin && <Icon type="arrow-right" />}
                            </div>
                            {list.length ? (
                                list.map((item, key) => (
                                    <Card
                                        key={key}
                                        title={item.title}
                                        cover={item.thumb_uri}
                                        link={item.link_url}
                                        time={item.publish_time || 0}
                                        navTitle={t('academy_header', undefined, 'Academy')}
                                        diggCount={item.digg_count}
                                        commentCount={item.comment_count}
                                        onClickCard={() => {
                                            Tea(EVENTS.CLICK_ACADEMY_RECOMMENDATION, { recommendation_type: 'detail' });
                                        }}
                                    />
                                ))
                            ) : (
                                <Empty />
                            )}
                        </div>
                    </>
                ) : null
            }
        />
    );
};

ArticleH5.loadData = loadSSRData;

export default ArticleH5;
